const apiCallMixin = {
  data () {
    return {
      callName: null,
      params: {},
      loading: false,
      results: null
    }
  },
  computed: {
    url () {
      return this.$store.getters.apiUrl
    },
    response () {
      return this.$store.state.api.response
    },
    currency () {
      return this.$store.state.api.currency
    },
    apiCreds () {
      // this is used so that we can watch when any API credentials change
      let host = this.$store.state.api.host
      let user = this.$store.state.api.user
      let password = this.$store.state.api.password
      return host + user + password
    }
  },
  created () {
    console.log('on created')
    this.$store.commit('setCallName', this.callName)
    this.updateParamsFromQuery()
    this.makeApiCall()
  },
  watch: {
    '$route' (to, from) {
      // Make an API call whenever the route changes (for example,
      // when parameters are updated)
      console.log('route changed')
      this.updateParamsFromQuery()
      this.makeApiCall()
    },
    apiCreds (to, from) {
      console.log('apiCreds changed')
      this.makeApiCall()
    }
  },
  methods: {
    validateForm () {
      // should be overridden in component
      return true
    },
    parseResponse (response, success) {
      // should be overridden in component
    },
    updateParamsFromQuery () {
      console.log('updateParamsFromQuery')
      for (let key in this.$route.query) {
        this.params[key] = this.$route.query[key]
      }
    },
    updateQueryFromParams () {
      console.log('updateQueryFromParams')
      let query = {}
      for (let key in this.params) {
        query[key] = this.params[key]
      }
      this.$router.push({query: query})
    },
    makeApiCall () {
      console.log('URL = ', this.url)
      this.$store.commit('setParams', this.params)
      this.$store.commit('setResponse', '')
      this.results = null
      if (!this.validateForm()) {
        return
      }
      this.loading = true
      let startTime = Date.now()
      this.$http.get(this.url).then(response => {
        console.log('SUCCESS')
        response.time = (Date.now() - startTime) / 1000
        this.loading = false
        this.$store.commit('setResponse', response)
        this.parseResponse(response, true)
        this.parseCurrency(response)
      }, response => {
        // error callback
        console.log('FAILURE')
        console.log(response)
        response.time = (Date.now() - startTime) / 1000
        this.loading = false
        this.$store.commit('setResponse', response)
        this.parseResponse(response, false)
        this.parseCurrency(null)
      })
    },
    parseCurrency (response) {
      // this method assumes currency info is in the same place in each call
      if (this.response && this.response.ok && this.response.body.currency_details) {
        let currencyCode = this.response.body.currency_code
        let currency = this.response.body.currency_details[currencyCode]
        this.$store.commit('setCurrency', currency)
      } else {
        this.$store.commit('setCurrency', null)
      }
    },
    formatPrice (priceFloat) {
      let currency = this.currency
      if (currency) {
        return currency.currency_pre_symbol + priceFloat.toFixed(2) + currency.currency_post_symbol
      }
      return priceFloat
    }
  }
}

export default apiCallMixin



// WEBPACK FOOTER //
// ./src/components/ApiCallMixin.js